import React from 'react'
import './SocialMedia.css'
import { SocialIcon } from 'react-social-icons'

export default function SocialMedia() {
    return(
        <div className={"social__media_btn"} >
            <SocialIcon network={"facebook"} style={{ height: 50, width: 50 }}  bgColor="#1572B4" fgColor="#fff" url={"https://www.facebook.com/"} />
            <SocialIcon network={"instagram"} style={{ height: 50, width: 50 }} bgColor="#1572B4"  fgColor={"#fff"} url={"https://www.instagram.com/?hl=en"} />
            <SocialIcon url={"https://www.linkedin.com/in/hamza-ezzourguane-7917a5155/"} bgColor="#1572B4" style={{ height: 50, width: 50 }}  fgColor={"#fff"} />
            <SocialIcon network="twitter" bgColor="#1572B4" fgColor={"#fff"} style={{ height: 50, width: 50 }}  />
        </div>
    )
}